import React from "react";
import BuyTokensMessage from "./BuyTokensMessage";
import InvestHere from "./InvestHere";
import Transactiontable from "./TransactionTable";
import "./css/BuyTokens.css";

const BuyTokens = (props) => {

    return (
        <>
            <div className="buytokens-wrapper">
                <div className="container">
                    <BuyTokensMessage />
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6">
                            <InvestHere
                                trxPrice={props.trxPrice}
                                onOpenModalLogin={props.onOpenModalLogin}
                            />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6">
                            <Transactiontable
                                isLoadingInvesters={props.isLoadingInvesters}
                                icoInvestersList={props.icoInvestersList}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>)
}

export default BuyTokens;